import { render } from "./App.vue?vue&type=template&id=45287936"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=45287936&lang=css"

import exportComponent from "E:\\svn\\1074排课\\01前端\\移动端\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__